import React, {Component} from 'react';
import users from "../../consumers/users";
import auth from "../../consumers/auth";
import {Link} from "react-router-dom";

function Admin(props) {

    const {reference, currentUser} = props;
    return (reference && currentUser) ? <Navigation {...props}/> : "";
}

class Navigation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            superAdmin: false
        };
    }

    componentDidMount() {
        const {reference, currentUser} = this.props;
        reference.child(currentUser.uid).on('value', this.handleChange.bind(this));
    }

    handleChange(snapshot) {
        this.setState({superAdmin: snapshot.val()});
    }

    render() {
        const {superAdmin} = this.state;
        if (superAdmin) {
            return (
                <li className="has-mega-menu">
                    <Link to="/admin">Admin</Link>
                    <ul>
                        <Link to="/admin/blog">Blog</Link>
                        <Link to="/admin/portfolio">Portfolio</Link>
                        <Link to="/admin/contact">Mensajes</Link>
                    </ul>
                </li>
            );
        }
        return "";
    }
}


const AdminLink = users(auth(Admin));
export default AdminLink;


// WEBPACK FOOTER //
// ./src/admin/subscribers/AdminLink.js